import { Props } from 'shared/@types';
import { MarkdownPage } from 'shared/components/markdown-page';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyScreen = ({ isInModal = false }: Props<{ isInModal?: boolean }>) => {
  const { t } = useTranslation('documents');

  return <MarkdownPage markdown={t('privacy_policy')} variant={isInModal ? 'modal' : 'page'} />;
};

export { PrivacyPolicyScreen };
